import { gql } from '@apollo/client';
import type { ParticipantSearch } from '../../../types/events';

export const FIND_PARTICIPANTS = gql`
  query findParticipants($eventUniqueCode: ID!, $phrase: String!) {
    findParticipants(eventUniqueCode: $eventUniqueCode, phrase: $phrase)
      @rest(
        type: "ParticipantSearch"
        path: "/v2/api/events/{args.eventUniqueCode}/participant-search?phrase={args.phrase}"
        method: "GET"
        endpoint: "bff"
      ) {
      exact
      other
    }
  }
`;

export type FindParticipantsVariables = {
  eventUniqueCode?: string;
  phrase: string;
};

export type FindParticipantsData = {
  findParticipants: ParticipantSearch;
};
